import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export const UpgradeDialog = ({ open, onUpgrade, onCancel }) => {
  return (
    <Dialog open={open}>
      <DialogTitle id="alert-dialog-title">Upgrade</DialogTitle>
      <DialogContent>
        <DialogContentText>
          You exceeded your free tier limit. Do you want to upgrade to a premium
          plan?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={onCancel} autoFocus>
          Cancel
        </Button>
        <Button color="primary" onClick={onUpgrade}>
          Upgrade
        </Button>
      </DialogActions>
    </Dialog>
  );
};
UpgradeDialog.propTypes = {
  open: PropTypes.bool,
  onUpgrade: PropTypes.func,
  onCancel: PropTypes.func
};

export default UpgradeDialog;
